import React from "react";
import { useParams } from "react-router-dom";

const InfographicsDetails = () => {
  const {slug} = useParams();
  return <div>InfographicsDetails: {slug}</div>;
};

export default InfographicsDetails;
